import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form, FormControl, Spinner } from "react-bootstrap";
import IconSearch from '../../../../styles/images/search-icon-small.png';
import IconClose from '../../../../styles/images/close.png';
import { handleChangeDataSearchAutoComplete } from '../../../../redux/actions/pages/main/search';
import axios from "axios";
import * as qs from "querystring";
import { BASE_SITE, SHOP_SEARCH_POST } from '../../../../apis'; 


const Search = (props) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { text, isLoading, result } = useSelector(state => state.search);

    const focusBox = React.createRef();
    const refListSearch = React.createRef();
    const cancelSearch = useRef(null);

    const handleSubmitFormSearch = () => {

    };

    const handleChangeInputSearch = (event) => {
        const {value} = event.target;

        dispatch(handleChangeDataSearchAutoComplete('text', value));

        const LIST_SEARCH = refListSearch.current;

        if (value.length >= 2) {
            callApiSearch(LIST_SEARCH, value);
        }
        else {
            const LIST_SEARCH = refListSearch.current;
            LIST_SEARCH.setAttribute("class", "list-auto-autocomplete hide");
            dispatch(handleChangeDataSearchAutoComplete('result', []));
        }
    };

    const handleOnFocusSearch = (event) => {
        const FOCUS_BOX = focusBox.current;
        FOCUS_BOX.setAttribute("class", "box-search d-flex align-items-center pl-3 custom-focus");
        handleChangeInputSearch(event);
    };

    const handleOnBlurSearch = () => {
        const FOCUS_BOX = focusBox.current;
        FOCUS_BOX.setAttribute("class", "box-search d-flex align-items-center pl-3");

        const LIST_SEARCH = refListSearch.current;
        setTimeout(() => {
            LIST_SEARCH.setAttribute("class", "list-auto-autocomplete hide");
        }, 100);
    };

    const removeTextSearch = () => {
        dispatch(handleChangeDataSearchAutoComplete('text', ''));
    };


    const callApiSearch = async (LIST_SEARCH, value) => {
        try {
            dispatch(handleChangeDataSearchAutoComplete('isLoading', true));

            if (cancelSearch.current) {
                cancelSearch.current('search canceled');
            }

            const response = await axios.post(BASE_SITE + SHOP_SEARCH_POST,
                qs.stringify({
                    search_text: value
                }), {
                    cancelToken: new axios.CancelToken(cancel => cancelSearch.current = cancel)
                });


            const {data} = response;

            if (data.status === 'ok') {
                dispatch(handleChangeDataSearchAutoComplete('result', data.shops));
                if (data.shops.length > 0) {
                    LIST_SEARCH.classList.add('show');
                    LIST_SEARCH.classList.remove('hide');
                } else {
                    LIST_SEARCH.setAttribute("class", "list-auto-autocomplete hide");
                }
            } else {
                LIST_SEARCH.setAttribute("class", "list-auto-autocomplete hide");
            }
            if (data)
                dispatch(handleChangeDataSearchAutoComplete('isLoading', false));

        } catch (e) {
            console.log(e);
        }
    }

    return (
        <>
        <Form onSubmit={handleSubmitFormSearch} className={'w-100 mt-3'}>
            <div className="box-search d-flex align-items-center pl-3" ref={focusBox}>
                <FormControl id=""
                                className={'input-search no-border h-100 px-0'}
                                onChange={handleChangeInputSearch} autoComplete={"off"}
                                onFocus={handleOnFocusSearch}
                                onBlur={handleOnBlurSearch}
                                value={text}
                                placeholder="جستجو"/>
                <div className="d-flex pr-3 h-100">
                    <div className="d-flex align-items-center mx-3">
                        { 
                            isLoading ? 
                                <Spinner className='spinner-input-search spinner-grow-sm' animation={"grow"}  />
                            : 
                                (text.length > 0 ? <img src={IconClose} className="spinner-input-search" alt="remove" onClick={removeTextSearch} /> : null)
                        }
                    </div>
                    
                    <div className="d-flex align-items-center">
                        <img src={IconSearch} width={23} />
                    </div>
                </div>
                    
            </div>
            <div className={'list-auto-autocomplete hide'} ref={refListSearch} >
                <ul className="text-left">
                    {result.map((item, index) => {
                        return <li key={index} onClick={() => navigate(`../shop/${item.id}/${item.title.replace(/[\u200C]/g, '-').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/[^\w\u0600-\u06FF-]+/g, '').replace(/^-+|-+$/g, '')}`)}>{item.title}</li>;
                    })}
                </ul>
            </div>
        </Form>
        </>
    );
}

export default Search;